module.exports = __webpack_public_path__ + "img/logo@3x.af7786cb.png";